import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import Home from "./pages/Home";
import TPU from "./pages/TPU";
import Products from "./pages/Products";
import Applications from "./pages/Applications";
import Industries from "./pages/Industries";
import Quality from "./pages/Quality";
import Logistics from "./pages/Logistics";
import Knowledge from "./pages/Knowledge";
import Downloads from "./pages/Downloads";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Portal from "./pages/Portal";
import TpuApplication from "./pages/TpuApplication";
import OtherPlastics from "./pages/OtherPlastics";
import Legal from "./pages/Legal";
import LabTest from "./pages/LabTest";
import KnowledgeArticle from "./pages/KnowledgeArticle";
import NordflexTpu from "./pages/NordflexTpu";
import AdminStats from "./pages/AdminStats";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function TrackPageview() {
  const { pathname } = useLocation();
  const lastSent = React.useRef(null);
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    if (lastSent.current === pathname) return;
    lastSent.current = pathname;
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/analytics/pageview`;
    try {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: pathname, referrer: document.referrer || "" }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) { /* ignore */ }
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <TrackPageview />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tpu" element={<TPU />} />
              <Route path="/tpu/:slug" element={<TpuApplication />} />
              <Route path="/produkte" element={<Products />} />
              <Route path="/produkte/nordflex-tpu" element={<NordflexTpu />} />
              <Route path="/andere-kunststoffe" element={<OtherPlastics />} />
              <Route path="/anwendungen" element={<Applications />} />
              <Route path="/branchen" element={<Industries />} />
              <Route path="/qualitaet" element={<Quality />} />
              <Route path="/qualitaet/:slug" element={<LabTest />} />
              <Route path="/logistik" element={<Logistics />} />
              <Route path="/wissen" element={<Knowledge />} />
              <Route path="/wissen/:slug" element={<KnowledgeArticle />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/ueber-uns" element={<About />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/kundenportal" element={<Portal />} />
              <Route path="/impressum" element={<Legal />} />
              <Route path="/datenschutz" element={<Legal />} />
              <Route path="/agb" element={<Legal />} />
              <Route path="/admin/stats" element={<AdminStats />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
          <CookieBanner />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
